import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from 'primeng/tabs';
import { Regulamin } from '../../../../../shared/models/regulamin';
import { AdminPanelRuleDetailsHistory } from '../admin-panel-rule-details-history/admin-panel-rule-details-history';
import { AdminPanelRuleDetailsBasic } from '../admin-panel-rule-details-basic/admin-panel-rule-details-basic';

@Component({
  selector: 'app-admin-panel-rule-details',
  imports: [
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    AdminPanelRuleDetailsHistory,
    AdminPanelRuleDetailsBasic,
  ],
  templateUrl: './admin-panel-rule-details.html',
  styleUrl: './admin-panel-rule-details.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelRuleDetails {
  protected readonly rule = input<Regulamin>();
}
